import React, { useEffect, useState } from "react";
import Topbar from "../../components/Topbar";
import Sidebar from "../../components/Sidebar";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";

function EditCoupon() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [token, setToken] = useState(sessionStorage.getItem("token"));
  const [formdata, setFormdata] = useState({
    type: "", // Changed from 'cupon_type' to 'type'
    code: "", // Changed from 'cupon_code' to 'code'
    value: "",
    starting_date: "",
    ending_date: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormdata((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (new Date(formdata.starting_date) > new Date(formdata.ending_date)) {
      toast.error("Start date cannot be after End date.");
      setLoading(false);
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_APIURL}api/coupon/update/${id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(formdata),
        }
      );

      let data;
      try {
        data = await response.json();
      } catch {
        data = { message: "Unexpected response from server" };
      }

      if (response.ok) {
        toast.success("Coupon updated successfully!");
        navigate("/coupons");
      } else {
        toast.error(data.message || "Failed to update Coupon");
      }
    } catch (error) {
      toast.error("Something went wrong! Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    return dateString.split("T")[0];
  };

  useEffect(() => {
    const fetchSingleCoupon = async () => {
      if (!token) {
        toast.error("No token provided!");
        return;
      }

      try {
        const response = await axios.get(
          `${process.env.REACT_APP_APIURL}api/coupon/details/${id}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.data?.data) {
          setFormdata({
            type: response?.data?.data?.type || "", // Updated to match new JSON key
            code: response?.data?.data?.code || "", // Updated to match new JSON key
            value: response?.data?.data?.value || "",
            starting_date: formatDate(response?.data?.data?.starting_date),
            ending_date: formatDate(response?.data?.data?.ending_date),
          });
        }
      } catch (error) {
        toast.error(
          "Error fetching data: " +
            (error.response?.data?.message || error.message)
        );
      }
    };

    fetchSingleCoupon();
  }, [id, token]);

  return (
    <>
      <Topbar />
      <Sidebar />
      <main id="main" className="main">
        <div className="pagetitle">
          <h1>Update Coupon</h1>
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/">Home</Link>
              </li>
              <li className="breadcrumb-item active">Update Coupon</li>
            </ol>
          </nav>
        </div>

        <div className="card">
          <div className="card-body">
            <form className="row g-3 pt-4" onSubmit={handleSubmit}>
              <div className="col-md-4">
                <div className="form-floating">
                  <select
                    className="form-select"
                    name="type" // Updated to 'type' from 'cupon_type'
                    value={formdata.type}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select Type</option>
                    <option value="fixed">Fixed</option>
                    <option value="percentage">Percentage</option>
                  </select>
                  <label htmlFor="type">Coupon Type</label>
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-floating">
                  <input
                    type="text"
                    className="form-control"
                    id="code" // Updated to 'code' from 'cupon_code'
                    placeholder="Enter Coupon Code"
                    name="code" // Updated to 'code' from 'cupon_code'
                    value={formdata.code}
                    onChange={handleChange}
                    required
                  />
                  <label htmlFor="code">Coupon Code</label>
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-floating">
                  <input
                    type="number"
                    className="form-control"
                    id="value"
                    placeholder="Enter Coupon Value"
                    name="value"
                    value={formdata.value}
                    onChange={handleChange}
                    required
                  />
                  <label htmlFor="value">Coupon Value</label>
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-floating">
                  <input
                    type="date"
                    className="form-control"
                    id="stdate"
                    name="starting_date"
                    value={formdata.starting_date}
                    onChange={handleChange}
                    required
                  />
                  <label htmlFor="stdate">Start Date</label>
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-floating">
                  <input
                    type="date"
                    className="form-control"
                    id="enddate"
                    name="ending_date"
                    value={formdata.ending_date}
                    onChange={handleChange}
                    required
                  />
                  <label htmlFor="enddate">End Date</label>
                </div>
              </div>

              <div className="text-start d-flex gap-3 mt-4">
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={loading}
                >
                  {loading ? "Updating..." : "Update Coupon"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </main>
    </>
  );
}

export default EditCoupon;
